import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { ArticleCard } from "@/components/ArticleCard";
import Breadcrumb from "@/components/Breadcrumb";
import SEO from "@/components/SEO";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (q.length < 2) {
      setResults([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    api.search(q)
      .then((r) => { if (!cancelled) setResults(r); })
      .catch(() => { if (!cancelled) setResults([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [q]);

  return (
    <>
      <SEO title={`Search: ${q}`} url={`/search?q=${encodeURIComponent(q)}`} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <Breadcrumb items={[{ label: "Home", to: "/" }, { label: "Search" }]} />
        <header className="border-b-2 border-foreground pb-6 mt-4">
          <div className="overline">Search</div>
          <h1 className="font-display font-black text-4xl md:text-5xl mt-2 tracking-tight">
            Results for <span className="italic">"{q}"</span>
          </h1>
          <p className="mt-2 text-foreground/60 font-mono text-sm">
            {loading ? "Searching…" : `${results.length} article${results.length === 1 ? "" : "s"} found`}
          </p>
        </header>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 mt-10">
          {results.map((a) => (
            <ArticleCard key={a.id} a={a} />
          ))}
        </div>
        {!loading && results.length === 0 && q && (
          <div className="py-24 text-center text-foreground/60">
            No results. Try a different keyword.
          </div>
        )}
      </div>
    </>
  );
}
